import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Food } from 'src/interfaces/food.model';
import { Locale } from 'src/interfaces/locale.model';

@Component({
    selector: 'app-menu-dialog-food-variants',
    templateUrl: './menu-dialog-food-variants.component.html',
    styleUrls: ['./menu-dialog-food-variants.component.css'],
    standalone: false
})

export class MenuDialogFoodVariantsComponent implements AfterViewInit {
  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
  ) {
    this.choise = this.food?.choise || 0;
    this.locale = this.dataService.locale;
  }

  @Input() food : Food | null = null;
  @Output() variantsChange = new EventEmitter(); // Output property

  choise: number;
  locale: Locale | null = null;

  onChoiseClick(): void {
    if (this.food) {
      console.log('MenuFoodDialogVariants | onChoiseClick() | index:', this.choise);
      this.food.choise = this.choise;
      this.variantsChange.emit(); // Emit updated modificators
    }
  }

  ngAfterViewInit() {
    if (this.food) this.choise = this.food.choise;
    this.cdr.detectChanges();
  }
}
